const Header = ({ intl, lastName, isRsvpForm, color, isFormSubmitted, isSubmitting }) => {
    const title =
        isFormSubmitted || isSubmitting
            ? !isRsvpForm
                ? intl.formatMessage(
                      {
                          id: 'features.Viewlogy.GuestSection.Form.thankyou',
                          defaultMessage: 'Thank you for supporting the {1} family',
                      },
                      { 1: lastName },
                  )
                : intl.formatMessage({
                      id: 'features.Viewlogy.GuestSection.Form.rsvpthankyou',
                      defaultMessage: "Thank you. We'll let you know of any updates.",
                  })
            : !isRsvpForm
              ? intl.formatMessage({
                    id: 'features.Viewlogy.GuestSection.Form.sign',
                    defaultMessage: 'Show that you attended',
                })
              : intl.formatMessage({ id: 'features.Viewlogy.GuestSection.Form.rsvp', defaultMessage: 'RSVP' });

    const firstSubtitleLine = !isRsvpForm
        ? intl.formatMessage({
              id: 'features.Viewlogy.GuestSection.Form.signFirstSubtitle',
              defaultMessage: 'give your love and support',
          })
        : intl.formatMessage({
              id: 'features.Viewlogy.GuestSection.Form.rsvpFirstSubtitle',
              defaultMessage: 'to receive new updates',
          });

    const secondSubtitleLine = !isRsvpForm
        ? intl.formatMessage({
              id: 'features.Viewlogy.GuestSection.Form.signSecondSubtitle',
              defaultMessage: ' ',
          })
        : intl.formatMessage({
              id: 'features.Viewlogy.GuestSection.Form.rsvpSecondSubtitle',
              defaultMessage: 'about the livestream',
          });

    return (
        <>
            <div>
                <p
                    className="video-message guest-form-header"
                    style={{ color, marginBottom: !isFormSubmitted && !isSubmitting ? '5px' : undefined }}
                >
                    {title}
                </p>
                {!isFormSubmitted && !isSubmitting && (
                    <p className="video-message guest-form-subtitle" style={{ color }}>
                        {firstSubtitleLine}
                        <br />
                        {secondSubtitleLine}
                    </p>
                )}
            </div>
        </>
    );
};

export default Header;
